import { CircleAlert } from "lucide-react";

import { ApiError } from "@/core/api/errors";

/** A save that failed for a reason no single field explains: the API's message and its reference. */
export function FormAlert({ error }: { error: unknown }) {
  if (!error) return null;
  const message = error instanceof Error ? error.message : "Something went wrong. Please try again.";
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <div
      role="alert"
      className="mb-5 flex gap-2.5 rounded-xl border border-danger-border bg-danger-soft px-3.5 py-3 text-sm text-ink"
    >
      <CircleAlert className="mt-0.5 size-[18px] shrink-0 text-danger" aria-hidden="true" />
      <div className="flex flex-col gap-0.5">
        <span>{message}</span>
        {requestId && <span className="text-xs text-muted">Reference: {requestId}</span>}
      </div>
    </div>
  );
}

/** After a failed check: move focus to the first field marked invalid (keyboard and screen-reader users). */
export function focusFirstInvalid(form: HTMLElement | null) {
  requestAnimationFrame(() => form?.querySelector<HTMLElement>('[aria-invalid="true"]')?.focus());
}
